import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const WashingCountHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        style={{ padding: 0 }}
        ghost={false}
        title={t('components.pages.washingCount.listReport.pageHeader.title')}
      />
    </>
  )
}

WashingCountHeader.displayName = 'WashingCountHeader'
export default WashingCountHeader
